import _nfDefault from "D:\\__sistem__\\Masaustu\\FikoYT.Yeni.Cag\\fikoyt-ana\\node_modules\\qs\\lib\\index.js";
export default _nfDefault;
const _nf0 = _nfDefault["formats"];
const _nf1 = _nfDefault["parse"];
const _nf2 = _nfDefault["stringify"];
export { _nf0 as formats, _nf1 as parse, _nf2 as stringify };
